import React, { useId } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  error?: string;
}
export function Input({
  label,
  helperText,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || useId();
  return <div className="w-full" data-id="element-71">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700 mb-1" data-id="element-72">
          {label}
        </label>}
      <input id={inputId} className={`flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-73" />
      {helperText && <p className="mt-1 text-xs text-slate-500" data-id="element-74">{helperText}</p>}
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-75">{error}</p>}
    </div>;
}